<table class="meeting-table">
  <tbody>

    @if (accountName) {
      <tr class="meeting-table__row">
        <td class="meeting-table__label">Account</td>
        <td class="meeting-table__value">{{ accountName }}</td>
        @if (showCopyButtons) {
          <td class="meeting-table__action">
            <button type="button" class="copy-btn" (click)="onCopy(accountName!, 'Account')" aria-label="Copy account name">
              <i class="pi pi-copy" aria-hidden="true"></i>
            </button>
          </td>
        }
      </tr>
    }

    @if (executive) {
      <tr class="meeting-table__row">
        <td class="meeting-table__label">Executive</td>
        <td class="meeting-table__value">{{ executive }}</td>
        @if (showCopyButtons) {
          <td class="meeting-table__action">
            <button type="button" class="copy-btn" (click)="onCopy(executive!, 'Executive')" aria-label="Copy executive name">
              <i class="pi pi-copy" aria-hidden="true"></i>
            </button>
          </td>
        }
      </tr>
    }

    @if (subject) {
      <tr class="meeting-table__row">
        <td class="meeting-table__label">Subject</td>
        <td class="meeting-table__value">{{ subject }}</td>
        @if (showCopyButtons) {
          <td class="meeting-table__action">
            <button type="button" class="copy-btn" (click)="onCopy(subject!, 'Subject')" aria-label="Copy subject">
              <i class="pi pi-copy" aria-hidden="true"></i>
            </button>
          </td>
        }
      </tr>
    }

    @if (startTime) {
      <tr class="meeting-table__row">
        <td class="meeting-table__label">Date &amp; Time</td>
        <td class="meeting-table__value">{{ displayTime(startTime) }}</td>
        @if (showCopyButtons) {
          <td class="meeting-table__action"></td>
        }
      </tr>
    }

    @if (attendeeEmail) {
      <tr class="meeting-table__row">
        <td class="meeting-table__label">Attendee</td>
        <td class="meeting-table__value">{{ attendeeEmail }}</td>
        @if (showCopyButtons) {
          <td class="meeting-table__action">
            <button type="button" class="copy-btn" (click)="onCopy(attendeeEmail!, 'Attendee email')" aria-label="Copy attendee email">
              <i class="pi pi-copy" aria-hidden="true"></i>
            </button>
          </td>
        }
      </tr>
    }

    @if (additionalGuests && additionalGuests.length > 0) {
      <tr class="meeting-table__row">
        <td class="meeting-table__label">Additional Guests</td>
        <td class="meeting-table__value">
          @for (guest of additionalGuests; track guest) {
            <div>{{ guest }}</div>
          }
        </td>
        @if (showCopyButtons) {
          <td class="meeting-table__action">
            <button type="button" class="copy-btn" (click)="onCopy(additionalGuests!.join(', '), 'Guest emails')" aria-label="Copy guest emails">
              <i class="pi pi-copy" aria-hidden="true"></i>
            </button>
          </td>
        }
      </tr>
    }

    @if (alreadyInvited && alreadyInvited.length > 0) {
      <tr class="meeting-table__row">
        <td class="meeting-table__label">Already invited</td>
        <td class="meeting-table__value">
          @for (email of alreadyInvited; track email) {
            <div>{{ email }}</div>
          }
        </td>
        @if (showCopyButtons) {
          <td class="meeting-table__action"></td>
        }
      </tr>
    }

  </tbody>
</table>
